<template>
  <div>
    <b-container v-if="isLoading" class="text-center d-flex justify-content-center">
      <b-form>
        <br><br><br>
        <h5>loading</h5>
        <br>
        <b-spinner style="color: rgb(109,122,82) !important"
          variant="warning"
        ></b-spinner>
      </b-form>
    </b-container>
    <div v-else>
      <b-container v-if="this.inSession">
        <b-row>
          <b-col align="center">
            <div class="menu-top" style="text-align:center">
              <p><b><span style="color: rgb(195,147,130)">WYNE</span></b>MAKER</p>
            </div>
            <div>
              <img class="menu-overlay"
                :src="require('@/assets/img/menu.png')"
                v-b-toggle.menu-sidebar
              >
            </div>  
            <hr>
            <div class="m-box">          
              <b-row class="justify-content-center" v-if="wine.image_files.length > 0">
                <b-carousel
                id="carousel-fade"
                :interval="4000"
                controls
                indicators
                background="#ffffff"
                img-width="100"
                img-height="300"
                style="width:max-content;height:auto"
                >
                  <b-carousel-slide v-for="image_file in wine.image_files" v-bind:key="image_file.dataURL">
                    <template v-slot:img>
                      <b-img   
                        v-bind:src="image_file.dataURL"
                        style="height:50vw;position:relative;right:0px"
                      />
                    </template>
                  </b-carousel-slide>
                </b-carousel>
              </b-row>
              <b-row v-else>
                <b-img center
                  style="height:50vw;position:relative;right:0px"
                  :src="require('@/assets/img/bottle.png')"
                ></b-img>
              </b-row> 
              <b-row>
                <b-col>
                  <div>
                    <div>
                      <h1 class="preview-title">{{this.wine.name}}</h1> 
                      <h5 class="preview-subtitle">{{this.wine.type}}</h5>
                      <hr>
                      <p class="preview-text">{{this.wine.region}}, {{this.wine.country}}</p>
                      <p class="preview-text">{{this.wine.appellation}}, {{this.wine.classification}}</p>

                    </div>
                    <div v-for="(value, key) in this.wine" v-bind:key="key">
                        <div v-if="key==='tasting_notes' && value.length>0">
                          <hr>
                          <div v-if="isTranslating">
                            <p class="w-text" style="font-style:italic; font-weight: bold;">translating…</p>
                            <p class="w-text" style="font-style:italic;">{{wine.tasting_notes}}</p>
                          </div>
                          <div v-else>
                            <p class="w-text" style="font-style:italic;">{{translatedText }}</p>
                          </div>
                        </div>  
                        <div v-if="key==='grapes' || key==='vines' || key==='vinification' || key === 'yields'">
                          <p  class="w-text" v-if="value.length>0"><b>{{ translate(key) }}</b> : {{value}}</p>
                        </div>
                      </div>
                    <hr>
                  </div>
                </b-col>
              </b-row>
            </div>
            <div class="m-box">
              <b-row >
                <b-button v-on:click="onBack()" class="w-button-pink-full">{{ translate("back") }}</b-button>
              </b-row>
            </div>
          </b-col>
        </b-row> 
        <b-sidebar 
          id="menu-sidebar" 
          backdrop
          backdrop-variant="dark" 
          no-header
          shadow
        >
          <template #default="{ hide }">
            <div class="menu-top" style="text-align:center">
              <p><b><span style="color: rgb(195,147,130)">WYNE</span></b>MAKER</p>
            </div>
            <div>
              <img class="menu-overlay"
                :src="require('@/assets/img/close.png')"
                @click="hide"
              >
            </div>
            <hr>
            <Menu/>
          </template>
        </b-sidebar>          
      </b-container>
      <NoAccess v-else></NoAccess>
    </div>
  </div>
</template>
<script>
  import {wordlist,translate_word} from '../assets/js/translate.js';
  import Translate from '../TranslateAI.js';

  import NoAccess from './NoAccess.vue'
  import Menu from './MenuMobile.vue'

  import Wines from '../Wines.js'
  
  export default {
    name: 'WineShows',
    components: {
      NoAccess,
      Menu,
    },
    computed : {
      inSession() {
        return this.$store.state.inSession
      },
      currentLanguage() {
        return this.$store.state.language
      }
    },
    watch: {
      'wine.tasting_notes': function () {
        this.scheduleTranslateText();
      },
      currentLanguage: function () {
        this.scheduleTranslateText();
      }
    },    
    data() {
      return {
        isLoading : true,
        wine: {},

        translatedText: '',
        isTranslating: false, 
        _translateTimer: null,
        _translateCache: {},
      }
    },
  async mounted(){
    if (this.debug) console.log('WineShow in mounted: START');
    
    await Wines.getone(this.$route.query.wine_id)
    .then(response => {
      this.wine = response
    })
    .catch(error => {
      console.log('WineShow in mounted: Catch await Wines.getone - ' + error);
    })
    this.scheduleTranslateText()
    this.isLoading = false;
  },
  methods: {
    onBack() {
      this.$router.push({path:'/Winery/Preview', query: {winery_id:this.$route.query.winery_id }})
    },
    translate(string) {
      return translate_word(string, this.currentLanguage);
    },

    scheduleTranslateText() {
      let local_debug = false

      if (!this._translateCache) this._translateCache = {};

      const textRaw = this.wine.tasting_notes || '';
      const text = textRaw.trim();
      const target = this.currentLanguage;

        if (local_debug || this.debug) {
          console.log("scheduleTranslateText: START", {
            currentLanguage: target,
            textLen: textRaw.length,
            textTrimLen: text.length,
            hasTimer: !!this._translateTimer,
            cacheSize: this._translateCache ? Object.keys(this._translateCache).length : 0,
          });
        }      

      // Always show original immediately
      this.translatedText = textRaw;

      if (!text) {
        if (local_debug || this.debug) console.log("scheduleTranslateText:  skip: empty text");
        this.isTranslating = false;
        return;
      }
      if (!target) {
        if (local_debug || this.debug) console.log("scheduleTranslateText:  skip: empty target");
        this.isTranslating = false;
        return;
      }

      // ✅ SHOW "translating…" while waiting
      this.isTranslating = true;

      if (this._translateTimer) {
        clearTimeout(this._translateTimer);
        if (local_debug || this.debug) console.log("scheduleTranslateText:  cleared previous timer");
      }

      this._translateTimer = setTimeout(() => {
        if (local_debug || this.debug) console.log("scheduleTranslateText:  firing translateTextNow()", { target, textTrimLen: text.length });
        this.translateTextNow(text, target);
      }, 350);

      if (local_debug || this.debug) console.log("scheduleTranslateText:  STOP - timer scheduled (350ms)");
    },
    async translateTextNow(text, target) {
      let local_debug = false

      if (!this._translateCache) this._translateCache = {};

      const cacheKey = `${target}||${text}`;

      if (local_debug || this.debug) {
        console.log("translateTextNow: START", {
          target,
          textTrimLen: text.length,
          cacheKeyPreview: cacheKey.slice(0, 80) + (cacheKey.length > 80 ? "…" : ""),
        });
      }

      // Cache hit
      if (Object.prototype.hasOwnProperty.call(this._translateCache, cacheKey)) {
        if (local_debug || this.debug) console.log("translateTextNow:  cache HIT");
        this.translatedText = this._translateCache[cacheKey];
        this.isTranslating = false; // ✅ DONE
        return;
      }

      if (local_debug || this.debug) console.log("translateTextNow:  cache MISS -> calling API");

      try {
        const res = await Translate.translate({ text, target, tone: 'natural' });
        const out = res?.translatedText || text;

        const stillSameText = ((this.wine.tasting_notes || '').trim() === text);
        const stillSameLang = (this.currentLanguage === target);

        if (stillSameText && stillSameLang) {
          this._translateCache[cacheKey] = out;
          this.translatedText = out;
          if (local_debug || this.debug) console.log("translateTextNow:  applied translation + cached");
        }
        else {
          if (local_debug || this.debug) console.log("translateTextNow:  NOT applied (text/lang changed while waiting)");
        }
      } catch (e) {
        const status = e?.response?.status;
        const data = e?.response?.data;
        const msg = e?.message;
        console.log("translateTextNow:  API ERROR", { status, msg, data, e });

        this.translatedText = this.wine.tasting_notes || '';
      } finally {
        this.isTranslating = false; // ✅ ALWAYS clear
      }
    },       
  }
  }
</script>

<style scoped>

</style>